import {Component, HostListener, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {first} from 'rxjs';
import {isPlatformBrowser} from '@angular/common';
import {CLOSE_EVENT} from '@app/services/iframe/iframe-message.service';

@UntilDestroy()
@Component({
  selector: 'dcp-default-modal',
  styleUrls: ['./default-modal.component.scss'],
  templateUrl: './default-modal.component.html',
})
export class DefaultModalComponent implements OnInit {
  @Input() modalId: string;
  topModalId: string | null = null;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Escape' && this.modalId === this.topModalId) {
      this.closeModal();
    }
  }

  private messageHandler: (event: any) => void = (event) => {
    if (event.data?.eventId === CLOSE_EVENT) {
      this.closeModal();
      event.stopPropagation();
    }
  };

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    protected modalService: DefaultModalService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('message', this.messageHandler, false);
    }
  }

  ngOnInit(): void {
    this.modalService.getTopModalId().pipe(first(), untilDestroyed(this)).subscribe(id => {
      this.topModalId = id;
    });
  }

  closeModal(): void {
    if (this.modalId) {
      this.modalService.closeModal(this.modalId);
    }
  }

}
